export default {
  APPROVAL_PAGE_NAME: 'Persetujuan',
  COMPLETED: 'Selesai',
  STATUS_APPROVAL: 'Status Persetujuan',
  SHIPPER: 'Pengirim',
  CREATED_AT: 'Pembuat',
  ACCEPTED: 'Menyetujui',
  REVISI: 'Revisi',
  REJECT: 'Menolak',
  INBOX: 'Kotak Masuk',
  INPROCESS: 'Dalam Proses',
  PIC: 'PIC',
};
